import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { mobileCSS } from '@measures/responsive'

const StyledSpecialPromoLineColorContainer = styled.div`
  flex: 1;
`

const StyledSpecialPromoLineColorElement = styled.div`
  ${({
    theme: {
      colors: { white },
    },
  }) => css`
    width: 100%;
    height: 2px;
    background-color: ${white};
  `}
`

const StyledLabelContainer = styled.div`
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  ${mobileCSS(css`
    display: none;
  `)}
`

const StyledSpecialPromoLine = styled.div`
  position: absolute;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  top: 8px;
  left: 0;
  padding: 0 8px 0 10px;
  line-height: 0;
`

const SpecialPromoLine: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => (
  <StyledSpecialPromoLine>
    <StyledSpecialPromoLineColorContainer>
      <StyledSpecialPromoLineColorElement />
    </StyledSpecialPromoLineColorContainer>
    <StyledLabelContainer>{children}</StyledLabelContainer>
  </StyledSpecialPromoLine>
)

export default SpecialPromoLine
